import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement } from '@nosto/preact'
import { useEffect } from 'preact/hooks'
import { formatCurrency, showSubtitle } from '../helpers'
import LoadSlotAutocomplete from '../serp/LoadSlotAutocomplete'

export default () => {
    const {
        response: { products, keywords },
    } = useAppState()

    useEffect(() => {
        const header = document.querySelector('#shopify-section-header')
        const searchHeader = document.querySelector('.header__search')
        const nsOverlay = document.querySelector('.ns-overlay')

        if (searchHeader && searchHeader.classList.contains('active--search') && !nsOverlay) {
            // Overlay element
            const nostoOverlay = document.createElement('div')
            nostoOverlay.className = 'ns-overlay'
            nostoOverlay.style.position = 'fixed'
            nostoOverlay.style.display = 'block'
            nostoOverlay.style.backgroundColor = '#406ac0cc'
            nostoOverlay.style.webkitBackdropFilter = 'blur(4px)'
            nostoOverlay.style.backdropFilter = 'blur(4px)'
            nostoOverlay.style.height = '100vh'
            nostoOverlay.style.width = '100vw'
            nostoOverlay.style.webkitTransition = 'opacity .25s ease'
            nostoOverlay.style.transition = 'opacity .25s ease'
            nostoOverlay.style.pointerEvents = 'none'
            nostoOverlay.style.zIndex = '12'
            nostoOverlay.style.opacity = '1'

            // Insert nostoOverlay before header
            if (header) {
                header.parentNode.insertBefore(nostoOverlay, header)
            }

            // Create a MutationObserver to watch for changes in searchHeader's class attribute
            const observer = new MutationObserver(() => {
                if (searchHeader.classList.contains('active--search')) {
                    nostoOverlay.style.opacity = '1'
                } else {
                    nostoOverlay.style.opacity = '0'
                }
            })

            observer.observe(searchHeader, { attributes: true, attributeFilter: ['class'] })

            return () => {
                observer.disconnect()
            }
        }
    }, [])

    const renderSubmitButton = () => (
        <div class="ns-autocomplete-submit ns-d-flex ns-justify-content-left">
            <button type="submit" class="ns-act-btn ns-text-align-left ns-w-100">
                See All Matching Products ({products?.total})
            </button>
        </div>
    )

    const getCustomFieldValue = (customFields, key) => {
        const field = customFields.find((field) => field.key === key)
        return field ? field.value : null
    }

    return (
        <>
            <div
                class="ns-ac ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
                data-nosto-element="autocomplete">
                <div class="ns-w-100 ns-mt-sm-auto">
                    <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                        {products?.hits?.length > 0 && (
                            <div
                                class={`ns-autocomplete-products ns-d-flex ns-flex-grow-1 nosto-autocomplete-prods-container`}>
                                <div class={`ns-d-flex`}>
                                    {products?.hits?.map((hit) => {
                                        return (
                                            <AutocompleteElement hit={hit}>
                                                <div
                                                    data-url={hit.url}
                                                    class="ns-d-flex ns-flex-column ns-clickable"
                                                    data-nosto-element="product">
                                                    <a href="javascript:void(0)">
                                                        <img
                                                            class="ns-h-auto ns-object-contain line-item__image"
                                                            src={hit.imageUrl}
                                                            alt={hit.name}
                                                            width="88"
                                                        />
                                                    </a>
                                                    <div class="nosto-autocomplete-info">
                                                        <h2 class="nosto-autocomplete-info__name">
                                                            <a href={hit.url}>{hit.name}</a>
                                                        </h2>
                                                        <h3 class="nosto-autocomplete-info__subtitle">
                                                            {hit?.customFields?.map((field) => {
                                                                if (field.key == 'pim-subtitle')
                                                                    return field.value
                                                            })}
                                                        </h3>
                                                        <div class="nosto-autocomplete-info__price">
                                                            {getCustomFieldValue(hit.customFields, 'bundle-display_price')
                                                                ? <span>${getCustomFieldValue(hit.customFields, 'bundle-display_price')}</span>
                                                                : <span>{formatCurrency(hit.price)}</span>
                                                            }
                                                            {getCustomFieldValue(hit.customFields, 'bundle-display_compare_at_price')
                                                                ? <span class="old-price">${getCustomFieldValue(hit.customFields, 'bundle-display_compare_at_price')}</span>
                                                                : hit.price < hit.listPrice && (
                                                                    <span class="old-price">
                                                                        {formatCurrency(hit.listPrice)}
                                                                    </span>
                                                                )
                                                            }
                                                            {getCustomFieldValue(
                                                                hit.customFields,
                                                                'pim-volume'
                                                            ) &&
                                                                (() => {
                                                                    const volume = getCustomFieldValue(
                                                                        hit.customFields,
                                                                        'pim-volume'
                                                                    )
                                                                    const parts = volume.split('/')
                                                                    if (parts.length > 1) {
                                                                        return (
                                                                            <>
                                                                                {' '}
                                                                                |{' '}
                                                                                <span className="nosto-autocomplete-info__size">
                                                                                    {parts[1].trim()}
                                                                                </span>
                                                                            </>
                                                                        )
                                                                    }
                                                                    return null
                                                                })()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </AutocompleteElement>
                                        )
                                    })}
                                </div>
                                {renderSubmitButton()}
                            </div>
                        )}
                        {products?.hits?.length == 0 && <LoadSlotAutocomplete />}
                    </div>
                </div>
            </div>
        </>
    )
}
